import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function PreTripDistance({ label, options, distance, onChange, isEditable }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={distance}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
